const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? 'https://api.followthecraft.com',
  slugUrlFormat: process.env.REACT_APP_SLUG_URL_FORMAT ?? 'https://%s.followthecraft.com',
}

export default config;
